import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
  ComplaintTypeState,
  complaintTypesFeatureKey
} from "../reducers/complaintType.reducer";
import { State } from "../index";

export const selectComplaintTypes = createFeatureSelector<
  ComplaintTypeState
>(complaintTypesFeatureKey);
export const getComplaintTypes = createSelector(
  selectComplaintTypes,
  data => data.complaintTypes
);
export const getComplaintTypesFetched = createSelector(
    selectComplaintTypes,
    data => data.fetched
  );

export const getComplaintTypeById = (props: { id: number }) => createSelector(getComplaintTypes, (items) => props?.id && items.find(item => item.Id === props.id));
